import { useState, useEffect } from 'react';
import { message } from 'antd';
import { LOCAL_STORAGE_KEYS } from '../constants/vinCode';

export const useCreditsManagement = getUserCredits => {
    const [currentCredits, setCurrentCredits] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isInsufficientModalVisible, setIsInsufficientModalVisible] = useState(false);
    const [isConfirmationModalVisible, setIsConfirmationModalVisible] = useState(false);

    const checkCredits = async (price = 1) => {
        try {
            const credits = await getUserCredits();
            setCurrentCredits(credits);

            if (credits >= price) {
                setIsConfirmationModalVisible(true);
            } else {
                setIsInsufficientModalVisible(true);
            }
        } catch (error) {
            console.error('Error checking credits:', error);
            message.error('An error occurred while checking credits.');
        }
    };

    useEffect(() => {
        const wasPaymentCompleted = localStorage.getItem(LOCAL_STORAGE_KEYS.PAYMENT_COMPLETED);
        if (wasPaymentCompleted) {
            localStorage.removeItem(LOCAL_STORAGE_KEYS.PAYMENT_COMPLETED);
            checkCredits();
        }
    }, []);

    return {
        currentCredits,
        isLoading,
        isInsufficientModalVisible,
        isConfirmationModalVisible,
        setIsLoading,
        setIsInsufficientModalVisible,
        setIsConfirmationModalVisible,
        checkCredits,
    };
};
